import { render } from "./OrdersIssues.vue?vue&type=template&id=25b281fa&scoped=true"
import script from "./OrdersIssues.vue?vue&type=script&lang=js"
export * from "./OrdersIssues.vue?vue&type=script&lang=js"

import "./OrdersIssues.vue?vue&type=style&index=0&id=25b281fa&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b281fa"]])

export default __exports__